import React from 'react';
import useLocale from '../../hooks/useLocale';

const Footer = () => {
  const { t } = useLocale();

  return (
    <footer style={{ background: '#0f172a', color: 'white', padding: '2rem 0', textAlign: 'center' }}>
      <div className="container">
        <p>
          &copy; {new Date().getFullYear()} Karim Menem. {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;